<div class="modal-visao" *ngIf="exibir">
  <div class="content">
    <h1 class="title">Selecione a visão desejada</h1>
    <div class="cards">
      <card-titulo-texto
        *ngIf="visaoHabilitada('cedente')"
        id="card-cedente"
        titulo="Visão Cedente"
        icone="faHandHoldingDollar"
        (click)="visaoCedente()"
      ></card-titulo-texto>
      <card-titulo-texto
        *ngIf="visaoHabilitada('sacado')"
        class="teste"
        id="card-sacado"
        titulo="Visão Sacado"
        icone="faMoneyCheckDollar"
        (click)="visaoSacado()"
      ></card-titulo-texto>
      <card-titulo-texto
        *ngIf="visaoHabilitada('investidor')"
        class="teste"
        id="card-investidor"
        titulo="Visão Investidor"
        icone="faChartColumn"
        (click)="visaoInvestidor()"
      ></card-titulo-texto>
    </div>
  </div>
</div>
